import React, { useEffect, createElement } from 'react';
import { useLanguage } from '../i18n/LanguageContext';
export function SEOHead({
  page
}: {
  page: 'home' | 'specialists' | 'companies';
}) {
  const {
    t,
    language
  } = useLanguage();
  useEffect(() => {
    // Set document title
    const seoTitle = t(`seo.${page}.title`);
    if (typeof seoTitle === 'string') {
      document.title = seoTitle;
    }
    // Set meta description
    const seoDesc = t(`seo.${page}.description`);
    let metaDesc = document.querySelector('meta[name="description"]') as HTMLMetaElement;
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = 'description';
      document.head.appendChild(metaDesc);
    }
    if (typeof seoDesc === 'string') {
      metaDesc.content = seoDesc;
    }
    // Map page to URL slug
    const pageSlugMap: Record<string, string> = {
      home: '',
      specialists: 'for-seafarers',
      companies: 'for-companies'
    };
    const pageSlug = pageSlugMap[page] || '';
    // Set canonical URL
    // EN is at root (no /en/), other langs have prefix
    const baseUrl = 'https://elvora.consulting';
    let canonicalUrl: string;
    if (language === 'en') {
      canonicalUrl = pageSlug ? `${baseUrl}/${pageSlug}` : `${baseUrl}/`;
    } else {
      canonicalUrl = pageSlug ? `${baseUrl}/${language}/${pageSlug}` : `${baseUrl}/${language}/`;
    }
    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = canonicalUrl;
    // Set hreflang tags
    const languages = ['en', 'ru', 'ua', 'ka'];
    // Remove existing hreflang links
    document.querySelectorAll('link[hreflang]').forEach(el => el.remove());
    languages.forEach(lang => {
      const link = document.createElement('link');
      link.rel = 'alternate';
      link.hreflang = lang === 'ua' ? 'uk' : lang; // ua → uk for proper ISO code
      if (lang === 'en') {
        link.href = pageSlug ? `${baseUrl}/${pageSlug}` : `${baseUrl}/`;
      } else {
        link.href = pageSlug ? `${baseUrl}/${lang}/${pageSlug}` : `${baseUrl}/${lang}/`;
      }
      document.head.appendChild(link);
    });
    // x-default hreflang → English (root)
    const xDefault = document.createElement('link');
    xDefault.rel = 'alternate';
    xDefault.hreflang = 'x-default';
    xDefault.href = pageSlug ? `${baseUrl}/${pageSlug}` : `${baseUrl}/`;
    document.head.appendChild(xDefault);
    return () => {
      // Cleanup hreflang on unmount
      document.querySelectorAll('link[hreflang]').forEach(el => el.remove());
    };
  }, [language, page, t]);
  return null;
}